/**
 * Get content of `<details>` tag
 * 
 * @param details Details tag element.
 * @returns Content of tag except `<summary>`.
 */
function getDetailsContent( details: HTMLElement ): Node[]
{
	const nodes: Node[] = [];
	
	for ( let i = 0, n = details.childNodes.length; i < n; i++ )
	{
		const node = details.childNodes[i];
		
		if ( node.nodeName !== 'SUMMARY' )
		{
			nodes.push( node );
		}
	}

	if ( document.body.classList.contains( 'promo' ) )
	{
		const form = document.querySelector( 'form' );

		if ( form )
		{
			nodes.push( form );
		}
	}

	return nodes;
}

/**
 * Module
 */
export {
	getDetailsContent as default,
};



// WEBPACK FOOTER //
// ./app/utils/getDetailsContent.ts